// 套餐购买
<template>
  <div :class="isPc ? 'tcgm width1394 d-flex' : 'tcgm width1394 d-flex-jc-se d-flex-fw-w d-flex'">
    <div class="item" v-for="(item, index) in tcgmList" :key="index">
      <p class="title">
        {{ item.title }}
        <span>{{ item.time }}分钟</span>
      </p>
      <p class="price">
        <b>¥</b>
        {{ item.amount }}
      </p>
      <div class="count d-flex">
        <span>购买数量：</span>
        <span class="input d-flex">
          <i class="del" @click="inputChange(index, 'del')"></i>
          <input
            type="text"
            :value="item.count"
            @input="countChange($event, index)"
          />
          <i class="add" @click="inputChange(index, 'add')"></i>
        </span>
      </div>
      <p class="text1">IP（{{ item.price }}元/个）：</p>
      <dl>
        <dd
          class="d-flex d-flex-aic"
          v-for="(che, cheIndex) in item.checkList"
          :key="cheIndex"
          @change="checkChange(index, cheIndex)"
        >
          <input
            type="radio"
            :name="item.checkName"
            :id="`${item.checkName}_${cheIndex}`"
            :checked="cheIndex == item.check"
          />
          <label :for="`${item.checkName}_${cheIndex}`">{{ che }}</label>
        </dd>
      </dl>
      <p class="text1">质量度：优质</p>
      <p class="text1">支持类型：HTTP,SOCK5</p>
      <a :href="item.link">购买</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numArray: [1000, 100000, 500000, 1000000],
      tcgmList: [
        {
          title: "套餐1",
          time: "1",
          price: "0.012",
          amount: 0.00,
          count: 1000,
          checkName: "tc1",
          checkList: ["10万以内", "10万", "50万", "100万"],
          check: 0,
          priceTemp: '{"1000":0.012,"100000":0.0108,"500000":0.00972,"1000000":0.00875}',
          link: process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/1?ip_count=1000',
          taocanId: 1,
          min: 1000,
          numArray: [1000, 100000, 500000, 1000000],
        },
        {
          title: "套餐2",
          time: "3",
          price: "0.013",
          amount: 0.00,
          count: 1000,
          checkName: "tc2",
          checkList: ["10万以内", "10万", "50万", "100万"],
          check: 0,
          priceTemp: '{"1000":0.013,"100000":0.0117,"500000":0.01053,"1000000":0.00948}',
          link: process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/2?ip_count=1000',
          taocanId: 2,
          min: 1000,
          numArray: [1000, 100000, 500000, 1000000],
        },
        {
          title: "套餐3",
          time: "5",
          price: "0.015",
          amount: 0.00,
          count: 1000,
          checkName: "tc3",
          checkList: ["10万以内", "10万", "50万", "100万"],
          check: 0,
          priceTemp: '{"1000":0.015,"100000":0.0135,"500000":0.01215,"1000000":0.01094}',
          link: process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/3?ip_count=1000',
          taocanId: 3,
          min: 1000,
          numArray: [1000, 100000, 500000, 1000000],
        },
        {
          title: "套餐4",
          time: "10",
          price: "0.02",
          amount: 0.00,
          count: 1000,
          checkName: "tc4",
          checkList: ["10万以内", "10万", "50万", "100万"],
          check: 0,
          priceTemp: '{"1000":0.02,"100000":0.018,"500000":0.0162,"1000000":0.01458}',
          link: process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/4?ip_count=1000',
          taocanId: 4,
          min: 1000,
          numArray: [1000, 100000, 500000, 1000000],
        },
        {
          title: "套餐5",
          time: "30",
          price: "0.05",
          amount: 0.00,
          count: 10000,
          checkName: "tc5",
          checkList: ["10万以内", "10万", "50万", "100万"],
          check: 0,
          priceTemp: '{"10000":0.05,"100000":0.045,"500000":0.0405,"1000000":0.03645}',
          link: process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/5?ip_count=5000',
          taocanId: 12,
          min: 10000,
          numArray: [10000, 100000, 500000, 1000000],
        },
      ],
    };
  },
  computed: {
    isPc() {
      return this.$store.state.config.windowW > 1080
    },
  },
  mounted() {

    console.dir(this.$store.state.config.windowW)

    for (let i in this.tcgmList) {
      this.freshPrice(i)
    }
  },
  methods: {
    inputChange(index, attr) {
      let count = parseInt(this.tcgmList[index].count);
      if (isNaN(count) || count < this.tcgmList[index].min) {
        count = this.tcgmList[index].min
      }
      if (attr == "del") {
        if (count <= 0) return;
        this.tcgmList[index].count--;
      } else {
        this.tcgmList[index].count++;
      }

      this.freshPrice(index)
    },
    countChange(e, index) {
      let count = e.target.value.replace(/[^\d]/g, "");
      if (isNaN(count) || count < this.tcgmList[index].min) {
        count = this.tcgmList[index].min
      }
      this.tcgmList[index].count = count
      if (this.tcgmList[index].count !== "") {
        this.tcgmList[index].count = parseInt(this.tcgmList[index].count);
      }
      this.freshPrice(index)
    },
    checkChange(index, cheIndex) {
      this.tcgmList[index].check = cheIndex;
      this.tcgmList[index].count = this.tcgmList[index].numArray[cheIndex];
      this.freshPrice(index)
    },
    freshPrice(index) {
      let count = this.tcgmList[index].count
      let temp = JSON.parse(this.tcgmList[index].priceTemp)

      let idxs = []
      let max = 0
      for (let i in temp) {
        idxs.push(i)
        max++
      }

      let idx = 0
      for (let i in temp) {
        i = Number(i)
        if (idx < max - 1) {
          if (count >= i && count < Number(idxs[idx+1])) {
            this.tcgmList[index].price = temp[i]
            this.tcgmList[index].amount = (temp[i] * count).toFixed(2)
            break
          }
        } else {
          if (count >= i) {
            this.tcgmList[index].price = temp[i]
            this.tcgmList[index].amount = (temp[i] * count).toFixed(2)
            break
          }
        }
        idx++
      }

      this.tcgmList[index].link = process.env.VUE_APP_PORTAL_URL + 'smallAgent/buy/' + this.tcgmList[index].taocanId + '?ip_count=' + count
    },
  },
};
</script>

<style lang="less" scoped>
.tcgm {
  padding: 67px 0 66px;
  .item {
    width: 300px;
    height: 712px;
    border: 1px solid #f78834;
    margin-top: 30px;
    border-radius: 16px;
    position: relative;
    transition: all 0.3s;
    .title {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      margin: 26px 0 0 30px;
      span {
        font-weight: normal;
        margin-left: 16px;
      }
    }
    .price {
      margin: 20px 0 20px 39px;
      font-size: 30px;
      color: #000;
      font-weight: bold;
      b {
        font-size: 40px;
        font-weight: normal;
      }
    }
    .count {
      margin-left: 39px;
      margin-bottom: 26px;
      .input {
        i {
          background-size: 100% 100%;
          width: 30px;
          height: 24px;
          line-height: 24px;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          &.del {
            margin-right: 1px;
            background: url("../../assets/images/del.png");
          }
          &.add {
            margin-left: 1px;
            background: url("../../assets/images/add.png");
          }
        }
        input {
          width: 88px;
          line-height: 24px;
          height: 24px;
          background: #f78834;
          border: none;
          color: #fff;
          text-align: center;
          outline: none;
        }
      }
    }
    .text1 {
      font-size: 18px;
      color: #000;
      margin-left: 39px;
    }
    dl {
      margin-left: 39px;
      margin-bottom: 20px;
      dd {
        margin-bottom: 14px;
        input[type="radio"] {
          appearance: none;
          content: "";
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #f78834;
          border-radius: 50%;
          vertical-align: middle;
          position: relative;
        }
        input[type="radio"]:checked:before {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #f78834;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
        }
        label {
          margin: 0;
        }
      }
    }
    a {
      display: inline-block;
      width: 168px;
      line-height: 48px;
      background: #f78834;
      font-size: 20px;
      color: #fff;
      text-align: center;
      border-radius: 10px;
      position: absolute;
      bottom: 46px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &:hover {
      box-shadow: 0 2px 20px 6px #fddec7;
    }
  }
}
@media (max-width: 1534px) {
  .tcgm {
    padding: 3% 0;
  }
  .tcgm .item {
    width: 24%;
  }
}
@media (max-width: 1480px) {
  .width1394 {
    width: 96%;
  }
  .tcgm .item .title,
  .tcgm .item .price,
  .tcgm .item .count {
    margin: 4% 0 0 6%;
  }
  .tcgm .item .text1 {
    margin-left: 6%;
  }
  .tcgm .item dl {
    margin-left: 6%;
  }
}
@media (max-width: 1200px) {
  .tcgm .item {
    width: 49%;
    height: 600px;
    margin-bottom: 2%;
  }
  .tcgm .item dl {
    display: flex;
    flex-wrap: wrap;
  }
  .tcgm .item dl dd {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .tcgm .item {
    width: 100%;
    height: 580px;
  }
  .tcgm .item .title {
    font-size: 20px;
  }
  .tcgm .item .title span,
  .tcgm .item .text1,
  .count span,
  .tcgm .item dl dd label,
  .tcgm .item a {
    font-size: 16px;
  }
  .tcgm .item .price b {
    font-size: 40px;
  }
  .tcgm .item .price {
    font-size: 30px;
  }
}
</style>
